import {
  fetchPickableVodRequests,
  fetchVodRequests,
  pickupVodRequest,
  retrievePreSignedUploadUrlByCoach,
  uploadVideoByCoach,
  completeVodRequest,
  declineVodRequest,
} from "../../../../api/vod"
import { v4 as uuidv4 } from "uuid"
const state = {
  pickableVodRequests: [],
  pendingVodRequests: [],
  editingRequest: null,
  editingStep: "preview",
  videoUrl: "",
  videoToUpload: null,
  videoMeta: null,
  uploadingProgress: 0,
  comments: [],
  addingComment: false,
  notes: "",
  requestCompleteError: "",
  recommendations: [
    { id: uuidv4(), recommendations: "" },
  ],
  timedOutRequest: null,
}
const getters = {
  pickableVodRequests: state => state.pickableVodRequests,
  pendingVodRequests: state => state.pendingVodRequests,
  editingRequest: state => state.editingRequest,
  editingStep: state => state.editingStep,
  videoUrl: state => state.videoUrl,
  uploadingProgress: state => state.uploadingProgress,
  videoToUpload: state => state.videoToUpload,
  comments: state => state.comments,
  addingComment: state => state.addingComment,
  notes: state => state.notes,
  recommendations: state => state.recommendations,
  videoMeta: state => state.videoMeta,
  requestCompleteError: state => state.requestCompleteError,
  timedOutRequest: state => state.timedOutRequest,
}
const mutations = {
  setPickableVodRequests: (state, requests) => (state.pickableVodRequests = requests),
  setPendingVodRequests: (state, requests) => (state.pendingVodRequests = requests),
  setEditingRequest: (state, request) => (state.editingRequest = request),
  setEditingStep: (state, step) => (state.editingStep = step),
  setVideoUrl: (state, videoUrl) => (state.videoUrl = videoUrl),
  setVideoToUpload: (state, video) => (state.videoToUpload = video),
  setUploadingProgress: (state, progress) => (state.uploadingProgress = progress),
  setComments: (state, comments) => (state.comments = comments),
  setAddingComment: (state, bol) => (state.addingComment = bol),
  setNotes: (state, notes) => (state.notes = notes),
  setVideoMeta: (state, videoMeta) => (state.videoMeta = videoMeta),
  setRecommendations: (state, recommendations) => (state.recommendations = recommendations),
  setRequestCompleteError: (state, requestCompleteError) => (state.requestCompleteError = requestCompleteError),
  setTimedOutRequest: (state, request) => (state.timedOutRequest = request),
}
const actions = {
  async loadPickableVodRequests ({ commit, rootGetters }) {
    try {
      const data = await fetchPickableVodRequests(rootGetters["User/Coaching/getInstaProAccessToken"])
      commit("setPickableVodRequests", data.data)
    } catch (error) {
      console.error(error)
    }
  },
  async loadPendingRequests ({ commit, rootGetters }) {
    try {
      const instaProAccessToken = rootGetters["User/Coaching/getInstaProAccessToken"]
      const data = await fetchVodRequests("laboring", instaProAccessToken)
      commit("setPendingVodRequests", data.result)
    } catch (error) {
      console.error(error)
    }
  },
  async pickupVodRequest ({ commit, rootGetters }, requestId) {
    const instaProAccessToken = rootGetters["User/Coaching/getInstaProAccessToken"]
    const data = await pickupVodRequest(requestId, instaProAccessToken)
    commit("setEditingRequest", data.result)
  },
  async declineVodRequest ({ commit, rootGetters, state }, requestId) {
    try {
      const instaProAccessToken = rootGetters["User/Coaching/getInstaProAccessToken"]
      await declineVodRequest(requestId, instaProAccessToken)
      const pickableRequests = state.pickableVodRequests.filter(request => request.id !== requestId)
      commit("setPickableVodRequests", pickableRequests)
    } catch (error) {
      console.error(error)
    }
  },
  setEditingRequest ({ commit }, request) {
    commit("setEditingRequest", request)
  },
  async uploadCommentaryVideo ({ commit, state, rootGetters }) {
    const instaProAccessToken = rootGetters["User/Coaching/getInstaProAccessToken"]
    const fileNameComponents = state.videoToUpload.name.split(".")
    const fileExtension = fileNameComponents[fileNameComponents.length - 1]
    const urls = await retrievePreSignedUploadUrlByCoach(instaProAccessToken, state.editingRequest.id, fileExtension)
    const data = await uploadVideoByCoach(urls.data.upload_url, state.videoToUpload)
    if (data.message) {
      alert(data.message)
      return
    }
    commit("setVideoUrl", urls.data.asset_url)
    commit("setUploadingProgress", 0)
  },
  async addComment ({ commit, state }, comment) {
    const comments = [...state.comments, comment]
    comments.sort((a, b) => a.at - b.at)
    await commit("setComments", comments)
  },
  async removeComment ({ commit, state }, removingComment) {
    const comments = state.comments.filter(comment =>
      comment.at !== removingComment.at
    )
    await commit("setComments", comments)
  },
  async addRecommendation ({ commit, state }) {
    const recommendations = [
      ...state.recommendations,
      {
        id: uuidv4(),
        recommendation: "",
      },
    ]
    await commit("setRecommendations", recommendations)
  },
  async removeRecommendation ({ commit, state }, id) {
    const recommendations = state.recommendations.filter(
      recommendation => (recommendation.id !== id)
    )
    await commit("setRecommendations", recommendations)
  },
  async editingRecommendation ({ commit, state }, editingRecommendation) {
    const recommendations = state.recommendations.map(
      recommendation => {
        if (recommendation.id === editingRecommendation.id) {
          return editingRecommendation
        } else {
          return recommendation
        }
      }
    )
    await commit("setRecommendations", recommendations)
  },
  async completeVodRequest ({ state, rootGetters, dispatch, commit }) {
    const recommendedTrainings = state.recommendations.map(recommendation => recommendation.recommendation)
    if (!state.videoUrl) {
      alert("Please attach a video commentary.")
      return
    }
    if (!state.comments.length) {
      alert("Please add some comments for the student.")
      return
    }
    if (!state.notes) {
      alert("Please leave some notes.")
      return
    }
    // eslint-disable-next-line camelcase
    const recommended_trainings = recommendedTrainings.filter(recommendation => recommendation)
    if (recommended_trainings.length <= 0) {
      alert("Please provide at least 1 recommendation for the student.")
    }
    const body = {
      generic_note: state.notes,
      feedbacks: [
        { url: state.videoUrl,
          comments: state.comments,
          metadata: state.videoMeta,
        },
      ],
      recommended_trainings,
    }
    const instaProAccessToken = rootGetters["User/Coaching/getInstaProAccessToken"]
    try {
      const data = await completeVodRequest(state.editingRequest.id, body, instaProAccessToken)
      if (data.message) {
        commit("setRequestCompleteError", data.message)
        alert(data.message)
      } else {
        await dispatch("loadPendingRequests")
        dispatch("clearEditing")
      }
    } catch (error) {
      console.error(error)
    }
  },
  clearEditing ({ commit }) {
    commit("setEditingRequest", null)
    commit("setEditingStep", "preview")
    commit("setVideoUrl", "")
    commit("setUploadingProgress", 0)
    commit("setComments", [])
    commit("setNotes", "")
    commit("setRecommendations", [
      { id: uuidv4(), recommendations: "" },
    ])
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/instapro/vod/coach.js